import { FC, useState } from "react";

import { FormStatus } from "@simplyk/common";

import { useTranslate } from "../../../../common/hooks/useTranslate";

import { useLiveFormEditorContext } from "./LiveFormEditorContext";

import { trpc } from "@/common/helpers/trpc";
import { SaveEditorModal } from "@/components/LiveEditorElements/SaveEditorModal/SaveEditorModal";

export const SaveFormModal: FC = () => {
  const { saveFormModalState, resetForm, apiFormObject, formType, saveCurrentStep } = useLiveFormEditorContext();
  const { isOpen, closeModalAndExecuteActions, closeModal } = saveFormModalState;
  const [isDeleting, setIsDeleting] = useState(false);
  const { t } = useTranslate();
  const { mutateAsync: deleteDonationForm } = trpc.deleteDonationForm.useMutation();
  const { mutateAsync: deleteTicketing } = trpc.deleteTicketing.useMutation();

  const handleDontSave = async () => {
    if (apiFormObject.status === FormStatus.Draft) {
      setIsDeleting(true);

      formType === "ticketing"
        ? await deleteTicketing({ ticketingId: apiFormObject.id, onlyDraft: true })
        : await deleteDonationForm({ donationFormId: apiFormObject.id, onlyDraft: true });
    }
    resetForm.current();
  };

  const handleSave = async () => {
    return saveCurrentStep.current();
  };

  const dialogTitle =
    apiFormObject.status === FormStatus.Draft
      ? t("dashboard", "common.backToDashboard.confirmationModal.titleDraft")
      : t("dashboard", "common.backToDashboard.confirmationModal.title");

  return (
    <SaveEditorModal
      isOpen={isOpen}
      onClose={closeModal}
      onCloseAndExecute={closeModalAndExecuteActions}
      onSave={handleSave}
      onDontSave={handleDontSave}
      title={dialogTitle}
      isSaveDisabled={isDeleting}
      isDontSaveDisabled={isDeleting}
      dataTestPrefix="save-form-modal"
    />
  );
};
